import React from "react";
import StatusBadge, {
  StatusBadgeColorVariant,
} from "@/shared/components/StatusBadge";
import { OrderSheetStatus } from "@/features/order-sheets/order-sheet.type";
import { convertOrderStatusToNew } from "@/shared/utils";
import { orderStatusOptionList } from "@/shared/constants/status";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface Props {
  status: OrderSheetStatus;
  isBuyer?: boolean;
}

// const orderStatusColorVariantMap = {
//   // 파란색 : 오더 완료, 오더 협의 중, 재오더 완료
//   ORDERED_TO_AGENCY: "blue",
//   ORDERED_TO_BOUTIQUE: "blue",
//   RESUBMIT_COMPLETED: "blue",
//
//   // 노란색 : 바이어 수정 필요, 바이어 승인 필요
//   RESUBMIT_REQUIRED: "yellow",
//   BOUTIQUE_CONFIRMED: "yellow",
//
//   // 초록색 : 오더 확정
//   BUYER_CONFIRMED: "green",
//
//   // 회색 : 오더 취소
//   CANCELED: "gray",
//
//   // (기획에 명시되지 않은 나머지 상태들은 “중립” 처리)
//   INITIAL_DRAFT: "white",
//   WORKING_DRAFT: "white",
//   AGENCY_CONFIRMED: "white",
//   MODIFICATION_REQUIRED: "white",
//   MODIFICATION_COMPLETED: "white",
//   COMPLETED: "white",
// } satisfies Record<OrderSheetStatus, StatusBadgeColorVariant>;

const orderStatusColorVariantMap: Record<
  OrderSheetStatus,
  StatusBadgeColorVariant
> = {
  // 파란색 : 오더 완료, 오더 협의 중, 재오더 완료
  ORDERED_TO_AGENCY: "blue",
  ORDERED_TO_BOUTIQUE: "blue",
  RESUBMIT_COMPLETED: "blue",
  TRANSPORTATION_COMPLETED: "blue",
  TRANSPORTATION_ING: "blue",

  // 노란색 : 바이어 수정 필요, 바이어 승인 필요
  RESUBMIT_REQUIRED: "yellow",
  BOUTIQUE_CONFIRMED: "yellow",

  // 초록색 : 오더 확정
  BUYER_CONFIRMED: "blue",

  // 회색 : 오더 취소
  CANCELED: "gray",

  // (기획에 명시되지 않은 나머지 상태들은 “중립” 처리)
  INITIAL_DRAFT: "white",
  WORKING_DRAFT: "white",
  AGENCY_CONFIRMED: "white",
  MODIFICATION_REQUIRED: "white",
  MODIFICATION_COMPLETED: "white",
  COMPLETED: "green",
};

function OrderStatusBadge({ status }: Props) {
  const { tTitle } = useI18nHelper();
  const currentStatus = orderStatusOptionList.find(
    (option) => option.value === convertOrderStatusToNew(status)
  )?.name;

  if (!currentStatus || currentStatus === "INITIAL_DRAFT") return null;

  return (
    <StatusBadge
      status={tTitle("order_history:" + currentStatus ?? "WORKING_DRAFT")}
      colorVariant={orderStatusColorVariantMap[status]}
      size={"medium"}
    />
  );
}

export default OrderStatusBadge;
